/* template */
<template><money-saving-ui :money-saving="(moneySaving)" :availabel-coupons="(availabelCoupons)" :activities-progress-length="(activitiesProgressLength)" :bubble-image="(bubbleImage)" @goto-history="goPersonal" @money-saving-click-transmit="moneySavingClick"/></template>

/* styles */
/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import mpx, { createComponent } from '@mpxjs/core'
import { TrackMap } from '../../lib/webx/common_methods/track_map'

createComponent({
  name: 'MoneySavingTips',
  properties: {
    moneySaving: Number,
    availabelCoupons: Number,
    activitiesProgressLength: Number,
    bubbleImage: String,
  },
  attached() {
    TrackMap.index.moneySavingBarExposed()
    // 本期 available coupons 数据有问题，暂不显示，所以所有都是购买历史，一定会曝光，后期如果后端改了，前端也要记得改
    // if (this.availabelCoupons) {
    //   TrackMap.index.moneySavingBarCouponsExposed.apply(this)
    // } else {
    //   TrackMap.index.moneySavingBarHistoryExposed()
    // }
    TrackMap.index.moneySavingBarHistoryExposed()
  },
  methods: {
    moneySavingClick() {
      this.triggerEvent('money-saving-click')
    },
    goPersonal() {
      // 本期 available coupons 数据有问题，暂不显示，所以所有都是购买历史，不区分埋点，以后显示出来的时候记得改一下
      // TrackMap.index.click(this.availabelCoupons ? TrackMap.index.click.CKType.Personal : TrackMap.index.click.CKType.History)
      TrackMap.index.click(TrackMap.index.click.CKType.History)
      mpx.navigateTo({ url: `personal?active=${this.availabelCoupons ? 'effecting' : 'purchase-history'}` })
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "money_saving_tips0de9f19b",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'money-saving-ui':getComponent(require("../common/money-saving-ui.mpx?component=true&componentId=money-saving-ui34d96f6a"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
